module.exports = __webpack_public_path__ + "static/Image_WOW_ChannelList-92511e48e958278dda604ff22ccea297.png";